"use client";

import { Button } from "@mui/material";
import { useCloneDialog } from "../Providers/CloneDialogContext";

export default function CancelButton() {
  const { closeCloneDialog } = useCloneDialog();

  return (
    <Button onClick={closeCloneDialog} type="button">
      Cancel
    </Button>
  );
}
